<template>
  <div class="d-flex flex-column flex-nowrap justify-start align-center">

    <template
      v-for="message in messages"
    >
      <v-alert
        :key="message.id"
        :value="visibility[message.id]"
        :type="message.type"
        :dismissible="message.dismissible"
        :icon="message.icon"
        width="100%"
        border="left"
        elevation="3"
        :text="message.type != null"
        v-bind:class="['notification-message', { 'pa-0': hasBody(message) }]"
        :transition="visibility[message.id] ? 'scroll-y-reverse-transition' : 'scroll-x-transition'"
        @input="removeMessage(message.id)"
      >
        <template v-slot:prepend v-if="message.icon === 'progress-circular'">
          <v-progress-circular
            indeterminate
            color="primary"
            size="20"
            width="3"
            class="mr-4"
          ></v-progress-circular>
        </template>

        <template v-slot:prepend v-else-if="message.type == null && message.icon != null">
          <v-icon
            color="primary"
            class="mr-4 bold-icon"
          >{{ message.icon }}</v-icon>
        </template>

        <template v-slot:close="{ toggle }" v-if="message.type == null && message.dismissible">
          <v-btn
            color="primary"
            class="v-alert__dismissible"
            small
            icon
            @click="toggle"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </template>
        <div v-html="message.title">
        </div>
        <div v-if="message.router">
            <a :href="message.router">{{ message.routerTitle }}</a>
          </div>
      </v-alert>
    </template>
  </div>
</template>

<script>

const ANIMATION_OUT_TIME = 300; // ms

export default {
  props: {
    messages: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  data({ messages }) {
    return {
      visibility: messages.reduce((tot, curr) => {
        // eslint-disable-next-line no-param-reassign
        tot[curr.id] = curr.visible;
        return tot;
      }, {}),
    };
  },
  computed: {
    hasBody() {
      return (message) => typeof message.text === 'string';
    },
  },
  methods: {
    removeMessage(id) {
      this.visibility[id] = false;
      this.$forceUpdate();
      setTimeout(() => {
        this.$store.dispatch('messages/removeNotificationMessage', id);
      }, ANIMATION_OUT_TIME);
    },
  },
  watch: {
    messages(newval) {
      newval.filter((m) => this.visibility[m.id] == null)
        .forEach((m) => {
          this.visibility[m.id] = false;
        });

      setTimeout(() => {
        newval.forEach((m) => {
          this.visibility[m.id] = m.visible;
          if (typeof m.timeout === 'number') {
            setTimeout(() => {
              this.removeMessage(m.id);
            }, m.timeout);
          }
        });
        this.$forceUpdate();
      }, 0);

      return newval;
    },
  },
};
</script>

<style lang="scss" scoped>
  .bold-icon::before {
    font-weight: 900 !important;
  }
  .v-alert.notification-message {
    background-color: #fff !important;
  }

  .v-alert__content > div {
    text-align: left !important;
  }

  ::v-deep .v-alert__dismissible {
    align-self: flex-start !important;
    padding-top: 25px !important;
  }
</style>
